// mutations
const SET_RESULTRACE = (state, payload) => {
  state.list_race = payload;
};
const SET_INPUTMASTERRACE = (state, payload) => {
  state.tempMasterRace = payload;
};
const SET_IDMASTERRACE = (state, payload) => {
  state.idMasterRace = payload;
};
export default {
  SET_RESULTRACE,
  SET_INPUTMASTERRACE,
  SET_IDMASTERRACE
};
